import * as components from "@components";
const Home = components.Home;
const Serviahorro = components.Serviahorro;
const Contactenos = components.Contactenos;
const PlanesAsistenciaContainer = components.PlanesAsistenciaContainer;
const CreditosPersonales = components.CreditosPersonales;
const CreditosProductivos = components.CreditosProductivos;
const CreditosHipotecarios = components.CreditosHipotecarios;
const AhorrosProgramados = components.AhorrosProgramados;
const Organizacion = components.Organizacion;
const ChatFormulario = components.ChatFormulario;

export const Routes = () => {
  return [
    {
      name: "AhorroCredito",
      keywords:
        "CS, Cs, cs, Home, home, Inicio, inicio, Principal, principal, Start, start, Corporación, corporación, Corporativo, corporativo, Empresarial, empresarial, Financiero, financiero, Perfil, perfil, Persona, persona, Banca, banca, Banco, banco, Quienes, quienes, Somos, son, Info, info, información",
      title: "Historia | Ahorro y Credito",
      h1: "Historia",
      description:
        "CS Ahorro y crédito continúa siendo ese aliado, amigo y experto solidario que le aconseja en cada etapa de su vida, porque SOMOS GENTE CON PROPÓSITO.",
      url: "/ahorro-credito/home",
      component: Home,
    },
    {
      name: "Contáctenos",
      keywords:
        "Contácto, Contacto, contacto, contáctanos, teléfono, Teléfono, Cliente, Atención, atención, soporte, Soporte, Asesoría, asesoría, asesoramiento, asesor, asesora, crédito, préstamo, credito, prestamo, bancario, Bancario, agente, Agente, Social, Red, Redes Sociales, redes sociales, Facebook, facebook, face, feis, feisbuc, feisbuk, correo, Correo, mail, Mail, Instagram, instagram, Youtube, youtube, yutú, yutu, Whatsapp, WhatsApp, wasáp, wasá, wasap, video, videyo, vídeo, Vídeo, Video",
      title: "Contáctenos | CS Grupo Financiero Coopeservidores",
      h1: "Información de Contacto de Ahorro y Crédito",
      description:
        "Encuentre aquí las diferentes formas de contacto que puede utilizar para comunicarse con nosotros.",
      url: "/ahorro-credito/contactenos",
      component: Contactenos,
    },
    {
      name: "Serviahorro",
      keywords: "Serviahorro, Serviahorro, Ahorro, ahorro, ",
      title: "Serviahorro",
      h1: "Serviahorro",
      description:
        "Nuestro serviahorro le permite realizar un ahorro de manera mensual y acceder a éste en el momento en que lo necesite.",
      url: "/ahorros/serviahorro",
      component: Serviahorro,
    },
    {
      name: "Planes de Asistencia",
      keywords: "Asistencia, plan, mascotas, accidentes",
      title: "Planes de Asistencia",
      h1: "Planes de Asistencia",
      description: "Planes de Asistencia.",
      url: "/asistencia/:id", //:id no debe ir vacio, si corresponde a uno de los planes se mostrará si no, se mostrará el menú de planes.
      component: PlanesAsistenciaContainer,
    },
    {
      name: "SobreAhorro",
      keywords:
        "Sobre Ahorro, Sobre ahorro, sobre ahorro, Sobre, sobre, Ahorro, ahorro, Crédito, crédito, Credito, credito",
      title: "Sobre Ahorro | Ahorro y Crédito",
      h1: "Información de Crédito Sobre Ahorro",
      description:
        "Nuestro serviahorro le permite realizar un ahorro de manera mensual y acceder a éste en el momento en que lo necesite.",
      url: "/ahorros/serviahorro",
      component: Serviahorro,
    },
    // {
    //   name: "CreditosPersonales",
    //   keywords:
    //     "Crédito Personal, Crédito personal, crédito personal, Créditos Personales, Créditos personales, créditos personales, Crédito, crédito, Credito, credito, Personal, personal, Ahorro, ahorro",
    //   title: "Créditos",
    //   h1: "Información de Crédito",
    //   description:
    //     "Encuentre aquí los diferentes créditos, así como sus beneficios, requisitos y condiciones para optar por un crédito.",
    //   url: "/ahorro-credito/:id",
    //   component: CreditosPersonales,
    // },
    {
      name: "CreditosPersonales",
      keywords:
        "Crédito Personal, Crédito personal, crédito personal, Créditos Personales, Créditos personales, créditos personales, Crédito, crédito, Credito, credito, Personal, personal, Ahorro, ahorro",
      title: "Préstamo",
      h1: "Información de Préstamo",
      description:
        "Encuentre aquí los diferentes créditos personales, así como sus beneficios, requisitos y condiciones para optar por un crédito personal.",
      url: "/creditos-personales/:id",
      component: CreditosPersonales,
    },
    {
      name: "CreditosProductivos",
      keywords:
        "Crédito Personal, Crédito personal, crédito personal, Créditos Personales, Créditos personales, créditos personales, Crédito, crédito, Credito, credito, Personal, personal, Ahorro, ahorro",
      title: "Préstamo",
      h1: "Información de Préstamo",
      description:
        "Encuentre aquí los diferentes créditos personales, así como sus beneficios, requisitos y condiciones para optar por un crédito personal.",
      url: "/creditos-productivos/:id",
      component: CreditosProductivos,
    },
    {
      name: "CreditosHipotecarios",
      keywords:
        "Crédito Hipotecario, Crédito hipotecario, crédito hipotecario, Créditos Hipotecarios, Créditos Hipotecarios, créditos hipotecarios, Crédito, crédito, Credito, credito, Hipotecario, hipotecario, Ahorro, ahorro",
      title: "Préstamo",
      h1: "Información de Préstamo",
      description:
        "Encuentre aquí los diferentes tipos de créditos hipotecarios, así como sus beneficios, requisitos y condiciones para optar por un crédito Hipotecario.",
      url: "/creditos-hipotecarios/:id",
      component: CreditosHipotecarios,
    },
    {
      name: "AhorrosProgramados",
      keywords:
        "Ahorros Programados, Ahorros programados, ahorros programados, Ahorros, ahorros, Ahorro, ahorro",
      title: "",
      h1: "Información de ",
      description:
        "Encuentre aquí los diferentes tipos de ahorros, así como sus monedas, tasas, beneficios, requisitos y condiciones para optar por el ahorro.",
      url: "/ahorro/:id",
      component: AhorrosProgramados,
    },
    {
      name: "Organizacion",
      keywords:
        "organización, asesoría, asesoramiento, asesor, asesora, crédito, préstamo, credito, prestamo, bancario, Bancario, agente, Agente, Social, Red, Redes Sociales, redes sociales, Facebook, facebook, face, feis, feisbuc, feisbuk, correo, Correo, mail, Mail, Instagram, instagram, Youtube, youtube, yutú, yutu, Whatsapp, WhatsApp, wasáp, wasá, wasap, video, videyo, vídeo, Vídeo, Video",
      title: "Organización | CS Grupo Financiero Coopeservidores",
      h1: "Información de Organización",
      description:
        "Encuentre aquí los detalles de la organización",
      url: "/ahorro-credito/organizacion",
      component: Organizacion,
    },
    {
      name: "ChatFormulario",
      keywords:
        "chat, asesoría, asesoramiento, asesor, asesora, crédito, préstamo, credito, prestamo, bancario, Bancario, agente, Agente, Social, Red, Redes Sociales, redes sociales, Facebook, facebook, face, feis, feisbuc, feisbuk, correo, Correo, mail, Mail, Instagram, instagram, Youtube, youtube, yutú, yutu, Whatsapp, WhatsApp, wasáp, wasá, wasap, video, videyo, vídeo, Vídeo, Video",
      title: "Chat | Ahorro y Crédito",
      h1: "Formulario",
      description: "Formulario del Chat",
      url: "/chat/formulario",
      component: ChatFormulario,
    },
  ];
};

export default Routes;
